import { render, staticRenderFns } from "./typeDetail.vue?vue&type=template&id=4d7ce865&scoped=true"
import script from "./typeDetail.vue?vue&type=script&lang=js"
export * from "./typeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ce865",
  null
  
)

export default component.exports